import { flows } from '@/parcours/flows';
import FlowPage from '@/pages/Prevention/FlowPage.vue';

// flowRoutes.ts
export function generateFlowRoutes() {
  return Object.values(flows).flatMap((flow) => {
    return Object.keys(flow.steps).map((step) => ({
      name: `flow-${flow.id}-${step}`,
      path: `/missions/:missionId/slots/:slotId/reservation/:reservationId${flow.basePath}/${step}`,
      component: FlowPage,
      meta: {
        flowId: flow.id,
        step,
        keepAlive: false,
      },
    }));
  });
}
